<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group search-wrapper">
          <label for="code" class="floatings text-uppercase">{{ reason }}
            <input type="text" class="form-control" id="code" name="code" v-model="code" @change="triggerInputFunction(code)" />
            <span class="close" @click="code=''"></span>
          </label>
          <span id="code-value" class="hidden">{{ code }}</span>
          <div class="text-success" id="inventoryCompleteMessage">{{ successMessage }}</div>
          <div class="invalid-feedback" v-if="errors">
            <span v-for="item in errors">{{ item }} </span><br>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden" id="TransferSearchResult" :data-route=currentRoute>{{ searchResult }}</div>
  </div>

</template>

<script>
export default {
  name: "BooksInInventory",
  props: ['inventory_id', 'library_id', 'current_library_id'],
  data(){
    return {
      errors: {},
      code: '',
      reason: '',
      searchResult: '',
      currentRoute: '',
      successMessage: '',
      book: {
        id: '',
        title: '',
        author: '',
        invent_number: '',
        code: '',
        price: '',
        added_to_acquisition_batch: '',
      },
      inventory: {
        id: '',
        library_id: '',
        status: '',
        user_id: '',
        doc_number: '',
        file: '',
        comment: '',
        created_at: '',
      }

    }
  },
  mounted() {
    this.currentRoute = window.location.pathname;
    if(window.location.pathname === '/library/reports/inventory') {
      this.reason = 'Введіть або відскануйте штрихкод щоб знайти книгу';
    } else if (
        window.location.pathname.indexOf("/library/reports/inventory/") !== -1
    ) {
      // if (this.$props.current_library_id === this.$props.library_from) {
      //   this.reason = 'Введіть або відскануйте штрихкод щоб додати книгу';
      // } else {
      //   this.reason = 'Відскануйте штрихкод щоб підтвердити отримання книги';
      // }
      this.reason = 'Введіть або відскануйте штрихкод щоб додати книгу';
    }
  },
  methods: {
    triggerInputFunction(code) {
      if (parseInt(this.$props.inventory_id)) {
        // if (this.$props.current_library_id === this.$props.library_from) {
        //   this.addBook(code);
        // } else {
        //   this.confirmInventoryBook(code);
        // }
        this.addBook(code);
      } else {
        this.searchInventoryContainingBook(code);
      }
    },

    // searchInventoryContainingBook(code) {
    //   this.searchResult = '';
    //   this.errors = [];
    //   if (!code) {
    //     return;
    //   }
    //   axios.get('/library/inventory/whereIsBook?library_id=' + this.$props.current_library_id + '&code=' + code + '&currentRoute=' + this.currentRoute).then(response => {
    //     if ('string' === typeof (response.data.data)) {
    //       this.errors.push(response.data.data);
    //       return;
    //     } else {
    //       this.searchResult = response.data.data;
    //     }
    //   }).catch(error => {
    //     this.errors = error.response.data.errors;
    //     console.log('Errors:');
    //     console.log(error.response.data.errors);
    //   });
    // },

    // confirmInventoryBook(code) {
    //   this.searchResult = '';
    //   this.errors = [];
    //   this.successMessage = '';
    //   if (!code) {
    //     return;
    //   }
    //   axios.put('/library/inventory/' + this.$props.inventory_id + '/acceptBook/' + code).then(response => {
    //     if ('string' === typeof (response.data)) {
    //       this.errors.push(response.data);
    //       return;
    //     }
    //     if (1 === response.data.isCompleted) {
    //       sessionStorage.setItem('inventoryCompleted', 1);
    //     }
    //     this.searchResult = response.data.data;
    //     this.successMessage = 'Успiшно';
    //   }).catch(error => {
    //     this.errors = error.response.data.errors;
    //     console.log('Errors:');
    //     console.log(error.response.data.errors);
    //   });
    // },

    addBook(code) {
      this.searchResult = '';
      this.errors = [];
      if (!code) {
        return;
      }
      axios.put('/library/reports/inventory/' + this.$props.inventory_id + '/addBook', {
        library_id: this.$props.library_id,
        code: code,
      }).then(response => {
        if ('string' === typeof (response.data.data)) {
          this.errors.push(response.data.data);
          return;
        }
        this.searchResult = response.data.data;
      }).catch(error => {
        this.errors = error.response.data.errors;
        console.log('Errors:');
        console.log(error.response.data.errors);
      });
    },
  },
}
</script>

<style scoped>
.invalid-feedback {
  display: block;
}

.invalid-feedback span {
  display: block;
}

.search-wrapper label {
  position: relative;
  width: 100%;
}

.close {
  position: absolute;
  top: 60%;
  right: 20px;
  width: 8px;
  height: 8px;
  opacity: 0.3;
  cursor: pointer;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 4px;
  content: ' ';
  height: 12px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

</style>